module.exports = __webpack_public_path__ + "static/media/chart.ee96f701.png";